module.exports = __webpack_public_path__ + "img/screenshot-warning-example.5b38cd06.png";